var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxDashboardOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6468 9.44604H12.216C11.9101 9.44604 11.6621 9.69402 11.6621 9.9999V16.6461C11.6621 16.952 11.9101 17.2 12.216 17.2H16.6468C16.9526 17.2 17.2006 16.952 17.2006 16.6461V9.9999C17.2006 9.69402 16.9526 9.44604 16.6468 9.44604Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6468 2.80005H12.216C11.9101 2.80005 11.6621 3.04802 11.6621 3.3539V5.58039C11.6621 5.88627 11.9101 6.13424 12.216 6.13424H16.6468C16.9526 6.13424 17.2006 5.88627 17.2006 5.58039V3.3539C17.2006 3.04802 16.9526 2.80005 16.6468 2.80005Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78545 2.80005H3.35463C3.04875 2.80005 2.80078 3.04802 2.80078 3.3539V10.0001C2.80078 10.306 3.04875 10.554 3.35463 10.554H7.78545C8.09133 10.554 8.3393 10.306 8.3393 10.0001V3.3539C8.3393 3.04802 8.09133 2.80005 7.78545 2.80005Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78545 13.866H3.35463C3.04875 13.866 2.80078 14.1139 2.80078 14.4198V16.6463C2.80078 16.9521 3.04875 17.2002 3.35463 17.2002H7.78545C8.09133 17.2002 8.3393 16.9521 8.3393 16.6463V14.4198C8.3393 14.1139 8.09133 13.866 7.78545 13.866Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxDashboardOutline);
export default __webpack_public_path__ + "static/media/icon_20px_dashboard_outline.5e88f226fca7520846fa6a246ca1247f.svg";
export { ForwardRef as ReactComponent };